module.exports = __webpack_public_path__ + "static/Stack Analytix-6b04e8faaec6c96e8ca12f7e534dc984.svg";